import { render, staticRenderFns } from "./SignInForm.vue?vue&type=template&id=0ff996c0"
import script from "./SignInForm.vue?vue&type=script&lang=js"
export * from "./SignInForm.vue?vue&type=script&lang=js"
import style0 from "./SignInForm.vue?vue&type=style&index=0&id=0ff996c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports